import { render, staticRenderFns } from "./PdOverview.vue?vue&type=template&id=a99138da&scoped=true&"
import script from "./PdOverview.vue?vue&type=script&lang=js&"
export * from "./PdOverview.vue?vue&type=script&lang=js&"
import style0 from "./PdOverview.vue?vue&type=style&index=0&id=a99138da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99138da",
  null
  
)

export default component.exports